export default {
  label: 'Servicegebühr bei Tischbestellungen erheben',
  description: 'Tischbestellungen zahlen keine Servicegebühr, solange dies aus ist.',
  no_fee: 'Ihr Restaurant erhebt keine Servicegebühr, also zahlen auch Tischbestellungen keine.',
  partner_default_on: 'Standard des Partners: an',
  partner_default_off: 'Standard des Partners: aus',
  toasts: {
    on: 'Tischbestellungen zahlen jetzt die Servicegebühr',
    off: 'Tischbestellungen zahlen jetzt keine Servicegebühr',
    error: 'Das wurde nicht gespeichert. Bitte versuchen Sie es erneut.',
  },
};
